import { Serializable } from './Serializable';

export class KeyDriverEvolutionDTO extends Serializable {
    keyDriverID: string;
    title: string;
    dateFrom: string;
    dateTo: string;
    period: string;
    // null mientras el key driver no tiene ninguna respuesta (en el período ni antes)
    score: number;
    // false cuando el período no tuvo respuestas y score repite el valor del período anterior
    hasResponses: boolean;

    constructor() {
        super();
    }

}
